export enum TASKS_TABLE_COLUMNS {
    TYPE = 'Type',
    STATUS = 'Status',
    PROGRESS = 'Progress',
    UPDATED_AT = 'UpdatedAt',
    CREATED_AT = 'CreatedAt',
    ACTIONS = 'Actions',
}

export const TASKS_PAGE_SIZE_OPTIONS = [5, 10];
export const TASKS_PAGE_DEFAULT_SIZE = 5;

export const TASKS_NEW_DEFAULT_EXPIRY_DAYS = 7;

export const TASKS_TABLE_HEADER = [
    TASKS_TABLE_COLUMNS.TYPE,
    TASKS_TABLE_COLUMNS.STATUS,
    TASKS_TABLE_COLUMNS.UPDATED_AT,
    TASKS_TABLE_COLUMNS.PROGRESS,
    TASKS_TABLE_COLUMNS.ACTIONS,
];

export enum ETaskStatus {
    CREATE = 1,
    ABORTED = 6,
    PENDING = 2,
    RUNNING = 3,
    SUCCESS = 0,
    ERROR = -1,
}

export const TASK_POLLING_INTERVAL = 2000;
